import Body from "../../commonComponents/body/Body";
import { Grid, Paper, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import * as Icons from "@tabler/icons-react";
import { formCardData } from "../../utils/formsData/FormCardData";
import { useMutation } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect } from "react";
import { postAPICall } from "../../services/apiCall";

const Forms = () => {
  const navigate = useNavigate();

  function onReportClick(item) {
    let url = `/forms/${item?.report_name
      ?.replace(/\s/g, "-")
      .toLowerCase()}`;
    url += `?name=${item?.api}`;
    return function () {
      navigate(url, {
        state: item,
      });
    };
  }

  const syncMutation = useMutation({
    mutationFn: () =>
      postAPICall("get-cockpit-data-from-coreops", {
        body: {
          start_date: dayjs().format("YYYY-MM-DD"),
          end_date: dayjs().format("YYYY-MM-DD"),
        },
      }),
    onSuccess: (res) => {
      console.log("SYNC success:", res);
    },
    onError: (err) => {
      console.error("SYNC error:", err);
    },
  });

  useEffect(() => {
    syncMutation.mutate();
  }, []);

  return (
    <Body>
      <Title>Forms</Title>
      <Grid mt={"md"}>
        {formCardData?.map((item) => {
          const ReportIcon = Icons[item?.icon || "IconChartDonut"];
          return (
            <Grid.Col span={2} key={item?.id}>
              <Paper
                shadow="sm"
                p={"sm"}
                style={{ cursor: "pointer" }}
                styles={{ root: { "&:hover": { backgroundColor: "red" } } }}
                onClick={onReportClick(item)}
              >
                <ReportIcon strokeWidth={1.25} size={36} color={"gray"} />
                <Text fw={500} size="md">
                  {item?.report_name}
                </Text>
                <Text c={"gray.6"} size="sm" lineClamp={3}>
                  {item?.purpose}
                </Text>
              </Paper>
            </Grid.Col>
          );
        })}
      </Grid>
    </Body>
  );
};

export default Forms;
